const TopListCard = ({ title, icon: Icon, iconClassName = "", items = [] }) => {
  return (
    <div className="rounded-lg bg-[#111827]/90 p-5 shadow-lg">
      <div className="mb-5 flex items-center gap-2">
        <Icon className={`h-5 w-5 ${iconClassName}`} />
        <h2 className="text-sm font-bold text-neutral-100">{title}</h2>
      </div>

      <div className="space-y-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-4 rounded-md bg-[#1B263A] px-4 py-3"
          >
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#00D3F2] to-[#9C6BFF] text-xs font-bold text-neutral-100">
              {item.id}
            </div>

            <div>
              <p className="text-sm font-semibold text-neutral-100">
                {item.name}
              </p>
              <p className="text-xs text-neutral-100/55">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopListCard;
